// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../imgs/menuBtn.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../imgs/logoBabitaW.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../imgs/logoBabita.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topMenu{
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top:0;
    background-color: var(--blackMain-color);
    width: 100%;
    max-width: 100%;
    height: 7vh;
    padding: 1vh 0; 
    z-index: 10000  !important;
}

.topMenu .btnsTop, .lateralMenu{
    display: flex;
    padding-right: 10px;
    font-family: "Montserrat", sans-serif;
    font-weight: 700;
    font-size: 1.2em;
    
}

.topMenu .btnsTop > div{
    padding: 9px;
    cursor: pointer;
}



.lateralMenu .menuCloseBtn, .topMenu .sideMenuBtn{
    display: flex;
    width: 30px;
    height: 30px;
    cursor: pointer;
    z-index: 15;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center/contain;
}

.topMenu .sideMenuBtn{
    position: relative;
    right: 0%;
}



.topMenu .logoTop{
    margin: 0 auto;
    height: 5vh;
    align-self: center;
    aspect-ratio: 350/111;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center/contain;
}


/* MENU LATERAL */

.lateralMenu{
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    /* padding: 2vw 0; */
    background-color: #fffbf5e6;
    z-index: 9999999 !important;
    color: var(--blackMain-color);
    text-align: center;
}

.lateralMenuRedirect{
    width: 100%;
    margin-top: 5%;
    font-size: 2em;
    text-align: start;
}

.lateralMenuRedirect > div{
    margin: 2% 0;
    cursor: pointer;
}

.lateralMenu .itemLateralMenu{
    font-size: 0.8em;
    font-weight: 600;
    margin-left: 15px;
}

.lateralMenu .topLateralMenu .logo{
    margin: 35px auto 15px auto;
    min-width: 41vw;
    max-width: 41vw;
    align-self: center;
    aspect-ratio: 350/111;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center/contain;
}



.lateralMenu .menuCloseBtn{
    position: absolute;
    right: 5%;
    top: 3%;
    padding: 9px;
}


.lateralMenuInicial{
    opacity: 0;
    width: 0;
    padding: 0;
    display: none;
}

.lateralMenu.mostraMenuLateral{
    animation: 1s showMenuMobile forwards 0s;
}

.lateralMenu.escondeMenuLateral{
    animation: 2s hideMenuMobile forwards 0s;
}


@media(max-width: 1400px){
    
}


@media(max-width: 767px){

    /* TOP MENU */

    .topMenu{
        height: 8vh;
        /* background-color: transparent; */
        margin-bottom: 15px;
    }
    /* .topMenu .btnsTop {
        width: 100%;
        height: 100%;
        justify-content: flex-end;
        align-items: center;
    } */


}


@keyframes showMenuMobile {
    0%{
        width: 0;
        padding: 0;
        opacity: 0;
    }
    20%{
        opacity: 1;
    }
    100%{
        opacity: 1;
        width: 100%;
        /* padding: 0 1.5%; */
    }
}


@keyframes hideMenuMobile {
    0%{
        width: 100%;
    }
    20%{
        opacity: 1;
    }
    40%{
        opacity: 0;
    }
    100%{
        opacity: 0;
        width: 0;
        padding: 0;
        display: none;
    }
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/topMenu.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,KAAK;IACL,wCAAwC;IACxC,WAAW;IACX,eAAe;IACf,WAAW;IACX,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;;AAEpB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;;;AAIA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,4EAA+D;AACnE;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;;;AAIA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,4EAAmE;AACvE;;;AAGA,iBAAiB;;AAEjB;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,4EAAkE;AACtE;;;;AAIA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;AAChB;;;AAGA;IACI,UAAU;IACV,QAAQ;IACR,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;;AAGA;;AAEA;;;AAGA;;IAEI,aAAa;;IAEb;QACI,WAAW;QACX,mCAAmC;QACnC,mBAAmB;IACvB;IACA;;;;;OAKG;;;AAGP;;;AAGA;IACI;QACI,QAAQ;QACR,UAAU;QACV,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;QACV,WAAW;QACX,qBAAqB;IACzB;AACJ;;;AAGA;IACI;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;QACV,QAAQ;QACR,UAAU;QACV,aAAa;IACjB;AACJ","sourcesContent":[".topMenu{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    position: fixed;\r\n    top:0;\r\n    background-color: var(--blackMain-color);\r\n    width: 100%;\r\n    max-width: 100%;\r\n    height: 7vh;\r\n    padding: 1vh 0; \r\n    z-index: 10000  !important;\r\n}\r\n\r\n.topMenu .btnsTop, .lateralMenu{\r\n    display: flex;\r\n    padding-right: 10px;\r\n    font-family: \"Montserrat\", sans-serif;\r\n    font-weight: 700;\r\n    font-size: 1.2em;\r\n    \r\n}\r\n\r\n.topMenu .btnsTop > div{\r\n    padding: 9px;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n\r\n.lateralMenu .menuCloseBtn, .topMenu .sideMenuBtn{\r\n    display: flex;\r\n    width: 30px;\r\n    height: 30px;\r\n    cursor: pointer;\r\n    z-index: 15;\r\n    background: url('../imgs/menuBtn.png') no-repeat center/contain;\r\n}\r\n\r\n.topMenu .sideMenuBtn{\r\n    position: relative;\r\n    right: 0%;\r\n}\r\n\r\n\r\n\r\n.topMenu .logoTop{\r\n    margin: 0 auto;\r\n    height: 5vh;\r\n    align-self: center;\r\n    aspect-ratio: 350/111;\r\n    background: url('../imgs/logoBabitaW.png') no-repeat center/contain;\r\n}\r\n\r\n\r\n/* MENU LATERAL */\r\n\r\n.lateralMenu{\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100vh;\r\n    /* padding: 2vw 0; */\r\n    background-color: #fffbf5e6;\r\n    z-index: 9999999 !important;\r\n    color: var(--blackMain-color);\r\n    text-align: center;\r\n}\r\n\r\n.lateralMenuRedirect{\r\n    width: 100%;\r\n    margin-top: 5%;\r\n    font-size: 2em;\r\n    text-align: start;\r\n}\r\n\r\n.lateralMenuRedirect > div{\r\n    margin: 2% 0;\r\n    cursor: pointer;\r\n}\r\n\r\n.lateralMenu .itemLateralMenu{\r\n    font-size: 0.8em;\r\n    font-weight: 600;\r\n    margin-left: 15px;\r\n}\r\n\r\n.lateralMenu .topLateralMenu .logo{\r\n    margin: 35px auto 15px auto;\r\n    min-width: 41vw;\r\n    max-width: 41vw;\r\n    align-self: center;\r\n    aspect-ratio: 350/111;\r\n    background: url('../imgs/logoBabita.png') no-repeat center/contain;\r\n}\r\n\r\n\r\n\r\n.lateralMenu .menuCloseBtn{\r\n    position: absolute;\r\n    right: 5%;\r\n    top: 3%;\r\n    padding: 9px;\r\n}\r\n\r\n\r\n.lateralMenuInicial{\r\n    opacity: 0;\r\n    width: 0;\r\n    padding: 0;\r\n    display: none;\r\n}\r\n\r\n.lateralMenu.mostraMenuLateral{\r\n    animation: 1s showMenuMobile forwards 0s;\r\n}\r\n\r\n.lateralMenu.escondeMenuLateral{\r\n    animation: 2s hideMenuMobile forwards 0s;\r\n}\r\n\r\n\r\n@media(max-width: 1400px){\r\n    \r\n}\r\n\r\n\r\n@media(max-width: 767px){\r\n\r\n    /* TOP MENU */\r\n\r\n    .topMenu{\r\n        height: 8vh;\r\n        /* background-color: transparent; */\r\n        margin-bottom: 15px;\r\n    }\r\n    /* .topMenu .btnsTop {\r\n        width: 100%;\r\n        height: 100%;\r\n        justify-content: flex-end;\r\n        align-items: center;\r\n    } */\r\n\r\n\r\n}\r\n\r\n\r\n@keyframes showMenuMobile {\r\n    0%{\r\n        width: 0;\r\n        padding: 0;\r\n        opacity: 0;\r\n    }\r\n    20%{\r\n        opacity: 1;\r\n    }\r\n    100%{\r\n        opacity: 1;\r\n        width: 100%;\r\n        /* padding: 0 1.5%; */\r\n    }\r\n}\r\n\r\n\r\n@keyframes hideMenuMobile {\r\n    0%{\r\n        width: 100%;\r\n    }\r\n    20%{\r\n        opacity: 1;\r\n    }\r\n    40%{\r\n        opacity: 0;\r\n    }\r\n    100%{\r\n        opacity: 0;\r\n        width: 0;\r\n        padding: 0;\r\n        display: none;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
